import { ReactNode } from 'react';

import ExpandingButtonContent from './Content';
import ExpandingButtonProvider from './context';

export type ExpandingButtonDirection = 'up' | 'down';

export interface ExpandingButtonProps {
  button: ReactNode;
  buttonId: string;
  content: ReactNode;
  direction?: ExpandingButtonDirection;
  milliseconds?: number;
}

const ExpandingButton: React.FunctionComponent<ExpandingButtonProps> =
  function (props) {
    return (
      <ExpandingButtonProvider {...props}>
        <ExpandingButtonContent />
      </ExpandingButtonProvider>
    );
  };

export default ExpandingButton;
